var $f0c4e76101f61910$exports = {};
$f0c4e76101f61910$exports = {
    "alert": `H\xe4lytys`,
    "dismiss": `Hylk\xe4\xe4`
};


export {$f0c4e76101f61910$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
